import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import OwlCarousel from "react-owl-carousel";
import InputGroup from "react-bootstrap/InputGroup";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import LoginLayout from "../Layout/LoginLayout";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../redux/actions/userActions";
import { Formik } from "formik";
import { userEditProfile } from "../redux/actions/userAuth";
import { Encryptedid } from "../utils/BcruptEncyptid";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

export default function AccountDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => ({
    userDetails: state.userMgmtSlice.userDetails,
  }));
  const [userDetailsState, setUserDetailsState] = useState();

  const [isActive, setActive] = useState(false);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    setUserDetailsState(userDetails);
  }, [userDetails]);
  return (
    <>
      <Helmet>
        <title>My Account - Salon Rated</title>
        <meta name="description" content="" />
      </Helmet>
      <LoginLayout>
        {/* Header section start  */}

        <section className="banner-img-signup">
          {/* top navbar start  */}

          {/* top navbar End  */}
        </section>

        {/* Header section End */}

        {/* Manage Your Account start */}

        <section className="Sign-main-section">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="Sign-main-text">
                  <h2 className="RecifeDisplay common-heading">
                    Manage Your Account
                  </h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="mx-auto">
                <div className="manage-account">
                  <div className="account-tab">
                    <ul>
                      <li className="active-tab">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99405 7.58932e-06C4.03185 0.00610029 -0.00365314 4.04648 2.48167e-06 9.00503C0.0036581 13.9645 4.05104 18.0073 9.00502 18C13.9684 17.9927 18.0042 13.952 17.9991 8.99406C17.9942 4.03246 13.9508 -0.00638975 8.99405 7.58932e-06ZM8.9971 16.3607C4.93509 16.3589 1.6365 13.0579 1.63864 8.9971C1.64077 4.93418 4.94058 1.63712 9.00228 1.63895C13.0655 1.64077 16.3626 4.93997 16.3607 9.00228C16.3586 13.0646 13.0585 16.3629 8.9971 16.3607Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M9.8123 10.6318C9.8123 11.4622 9.81718 12.293 9.80987 13.1234C9.80652 13.474 9.57469 13.7637 9.24782 13.8673C8.9179 13.9718 8.55629 13.8734 8.36133 13.5861C8.26933 13.4509 8.195 13.2717 8.19378 13.1118C8.18159 11.4634 8.18251 9.81475 8.1886 8.16636C8.19012 7.71215 8.55294 7.36517 8.99588 7.36243C9.44431 7.35969 9.80743 7.71246 9.81139 8.17825C9.81901 8.99589 9.81352 9.81383 9.81352 10.6318H9.8123Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M9.81292 4.90342C9.81566 5.35824 9.45832 5.7241 9.00655 5.72989C8.55843 5.73507 8.18921 5.3692 8.18647 4.91713C8.18342 4.46261 8.54168 4.09644 8.99254 4.09309C9.44461 4.08943 9.81017 4.45073 9.81292 4.90342Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/accountdetails">Account Details</Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99405 7.58932e-06C4.03185 0.00610029 -0.00365314 4.04648 2.48167e-06 9.00503C0.0036581 13.9645 4.05104 18.0073 9.00502 18C13.9684 17.9927 18.0042 13.952 17.9991 8.99406C17.9942 4.03246 13.9508 -0.00638975 8.99405 7.58932e-06ZM8.9971 16.3607C4.93509 16.3589 1.6365 13.0579 1.63864 8.9971C1.64077 4.93418 4.94058 1.63712 9.00228 1.63895C13.0655 1.64077 16.3626 4.93997 16.3607 9.00228C16.3586 13.0646 13.0585 16.3629 8.9971 16.3607Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M9.8123 10.6318C9.8123 11.4622 9.81718 12.293 9.80987 13.1234C9.80652 13.474 9.57469 13.7637 9.24782 13.8673C8.9179 13.9718 8.55629 13.8734 8.36133 13.5861C8.26933 13.4509 8.195 13.2717 8.19378 13.1118C8.18159 11.4634 8.18251 9.81475 8.1886 8.16636C8.19012 7.71215 8.55294 7.36517 8.99588 7.36243C9.44431 7.35969 9.80743 7.71246 9.81139 8.17825C9.81901 8.99589 9.81352 9.81383 9.81352 10.6318H9.8123Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M9.81292 4.90342C9.81566 5.35824 9.45832 5.7241 9.00655 5.72989C8.55843 5.73507 8.18921 5.3692 8.18647 4.91713C8.18342 4.46261 8.54168 4.09644 8.99254 4.09309C9.44461 4.08943 9.81017 4.45073 9.81292 4.90342Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/password-security">
                          {" "}
                          Password & Security
                        </Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                          >
                            <path
                              d="M19.9998 7.69255C19.9914 6.80962 19.9993 5.9267 19.9976 5.04377C19.9953 3.95332 19.2531 3.18606 18.1852 3.17946C17.2417 3.17372 16.298 3.17831 15.3545 3.17831H15.1156C15.1156 2.89415 15.1224 2.62433 15.1136 2.35538C15.1038 2.0514 15.1187 1.73882 15.0548 1.44547C14.8725 0.605309 14.149 0.0140109 13.2872 0.00970529C11.0941 -0.00177621 8.9007 -0.00493278 6.7076 0.0105672C5.66649 0.0177432 4.89071 0.853022 4.88283 1.92023C4.87974 2.33069 4.88227 2.74144 4.88227 3.17831H4.65998C3.74886 3.17831 2.83774 3.17803 1.92663 3.17831C0.892827 3.1786 0.293201 3.64906 0.0241994 4.66976C0.0211042 4.68124 0.0081601 4.68957 0 4.69961V8.08608C0.110583 8.65786 0.344975 9.16448 0.741444 9.59188C0.784495 9.63809 0.779711 9.74028 0.779711 9.81663C0.781681 11.9011 0.780837 13.9856 0.781399 16.07C0.781399 17.2449 1.52087 17.9998 2.67229 17.9998C7.55991 18.0001 12.4472 18.0001 17.3349 17.9998C18.4753 17.9995 19.2162 17.2437 19.2165 16.0809C19.217 13.9965 19.2179 11.9117 19.2142 9.82725C19.2139 9.69349 19.2443 9.59303 19.3344 9.49027C19.7804 8.97963 20.0069 8.38345 19.9998 7.69255ZM6.05958 1.83641C6.07224 1.46987 6.37219 1.2055 6.75712 1.20206C7.32327 1.19689 7.88941 1.20063 8.45555 1.20063C10.0169 1.20063 11.5786 1.20034 13.1403 1.20063C13.6876 1.20063 13.9434 1.45982 13.9436 2.01294C13.9442 2.39097 13.9439 2.769 13.9439 3.16253H6.05592C6.05592 2.7113 6.04438 2.27328 6.05958 1.83641ZM18.0451 10.7191C18.0451 12.5116 18.0451 14.3045 18.0448 16.097C18.0448 16.5735 17.818 16.8043 17.3492 16.8046C12.4481 16.8048 7.54697 16.8048 2.64584 16.8043C2.17931 16.8043 1.95308 16.5721 1.95308 16.0947C1.9528 14.3019 1.9528 12.5093 1.9528 10.7165V10.5632C2.64218 10.8178 3.30934 11.0965 3.99592 11.3107C5.19517 11.6847 6.43607 11.8391 7.68147 11.9473C7.89419 11.9657 8.0135 12.0119 8.08947 12.253C8.37676 13.1649 9.27437 13.6934 10.271 13.5642C11.1315 13.4528 11.7013 12.9712 11.9526 12.123C12.0089 11.9324 12.1414 11.9754 12.2576 11.9582C13.1772 11.8222 14.1021 11.7174 15.016 11.5495C16.0422 11.3609 17.0332 11.0388 17.9652 10.5483C17.9815 10.5397 18.0003 10.5362 18.0451 10.521V10.7191ZM9.13987 10.8325H10.8743C10.8549 11.1763 10.8763 11.5239 10.8057 11.8509C10.719 12.2521 10.2972 12.447 9.81435 12.3747C9.41957 12.3156 9.14832 12.0073 9.14072 11.6006C9.13593 11.3506 9.13987 11.1003 9.13987 10.8325ZM18.2294 8.93399C17.6793 9.42224 17.0265 9.71731 16.3469 9.95441C14.9656 10.4369 13.5348 10.6582 12.0848 10.773C12.0736 10.7739 12.0615 10.7661 12.03 10.7564C12.03 10.5916 12.0328 10.4206 12.0294 10.2495C12.0221 9.8838 11.786 9.63666 11.4267 9.63493C10.4764 9.63034 9.52621 9.63063 8.57598 9.63465C8.20653 9.63637 7.97326 9.88495 7.9682 10.2647C7.96623 10.4295 7.96792 10.5942 7.96792 10.7974C7.32974 10.7153 6.71098 10.6502 6.09672 10.5537C5.0148 10.3841 3.95455 10.1238 2.94861 9.67024C2.50065 9.46817 2.07604 9.22476 1.7139 8.88204C1.35345 8.54075 1.15508 8.13717 1.16661 7.61678C1.18547 6.76083 1.17111 5.90402 1.17196 5.0475C1.17252 4.60747 1.40072 4.37411 1.83602 4.37411C7.27684 4.37325 12.7177 4.37325 18.1585 4.37411C18.6025 4.37411 18.8256 4.60719 18.8259 5.06444C18.8265 5.90747 18.8099 6.75107 18.8318 7.59381C18.8467 8.15411 18.6275 8.58064 18.2294 8.93399Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/businessdetails">Business Details</Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                          >
                            <path
                              d="M19.9998 7.69255C19.9914 6.80962 19.9993 5.9267 19.9976 5.04377C19.9953 3.95332 19.2531 3.18606 18.1852 3.17946C17.2417 3.17372 16.298 3.17831 15.3545 3.17831H15.1156C15.1156 2.89415 15.1224 2.62433 15.1136 2.35538C15.1038 2.0514 15.1187 1.73882 15.0548 1.44547C14.8725 0.605309 14.149 0.0140109 13.2872 0.00970529C11.0941 -0.00177621 8.9007 -0.00493278 6.7076 0.0105672C5.66649 0.0177432 4.89071 0.853022 4.88283 1.92023C4.87974 2.33069 4.88227 2.74144 4.88227 3.17831H4.65998C3.74886 3.17831 2.83774 3.17803 1.92663 3.17831C0.892827 3.1786 0.293201 3.64906 0.0241994 4.66976C0.0211042 4.68124 0.0081601 4.68957 0 4.69961V8.08608C0.110583 8.65786 0.344975 9.16448 0.741444 9.59188C0.784495 9.63809 0.779711 9.74028 0.779711 9.81663C0.781681 11.9011 0.780837 13.9856 0.781399 16.07C0.781399 17.2449 1.52087 17.9998 2.67229 17.9998C7.55991 18.0001 12.4472 18.0001 17.3349 17.9998C18.4753 17.9995 19.2162 17.2437 19.2165 16.0809C19.217 13.9965 19.2179 11.9117 19.2142 9.82725C19.2139 9.69349 19.2443 9.59303 19.3344 9.49027C19.7804 8.97963 20.0069 8.38345 19.9998 7.69255ZM6.05958 1.83641C6.07224 1.46987 6.37219 1.2055 6.75712 1.20206C7.32327 1.19689 7.88941 1.20063 8.45555 1.20063C10.0169 1.20063 11.5786 1.20034 13.1403 1.20063C13.6876 1.20063 13.9434 1.45982 13.9436 2.01294C13.9442 2.39097 13.9439 2.769 13.9439 3.16253H6.05592C6.05592 2.7113 6.04438 2.27328 6.05958 1.83641ZM18.0451 10.7191C18.0451 12.5116 18.0451 14.3045 18.0448 16.097C18.0448 16.5735 17.818 16.8043 17.3492 16.8046C12.4481 16.8048 7.54697 16.8048 2.64584 16.8043C2.17931 16.8043 1.95308 16.5721 1.95308 16.0947C1.9528 14.3019 1.9528 12.5093 1.9528 10.7165V10.5632C2.64218 10.8178 3.30934 11.0965 3.99592 11.3107C5.19517 11.6847 6.43607 11.8391 7.68147 11.9473C7.89419 11.9657 8.0135 12.0119 8.08947 12.253C8.37676 13.1649 9.27437 13.6934 10.271 13.5642C11.1315 13.4528 11.7013 12.9712 11.9526 12.123C12.0089 11.9324 12.1414 11.9754 12.2576 11.9582C13.1772 11.8222 14.1021 11.7174 15.016 11.5495C16.0422 11.3609 17.0332 11.0388 17.9652 10.5483C17.9815 10.5397 18.0003 10.5362 18.0451 10.521V10.7191ZM9.13987 10.8325H10.8743C10.8549 11.1763 10.8763 11.5239 10.8057 11.8509C10.719 12.2521 10.2972 12.447 9.81435 12.3747C9.41957 12.3156 9.14832 12.0073 9.14072 11.6006C9.13593 11.3506 9.13987 11.1003 9.13987 10.8325ZM18.2294 8.93399C17.6793 9.42224 17.0265 9.71731 16.3469 9.95441C14.9656 10.4369 13.5348 10.6582 12.0848 10.773C12.0736 10.7739 12.0615 10.7661 12.03 10.7564C12.03 10.5916 12.0328 10.4206 12.0294 10.2495C12.0221 9.8838 11.786 9.63666 11.4267 9.63493C10.4764 9.63034 9.52621 9.63063 8.57598 9.63465C8.20653 9.63637 7.97326 9.88495 7.9682 10.2647C7.96623 10.4295 7.96792 10.5942 7.96792 10.7974C7.32974 10.7153 6.71098 10.6502 6.09672 10.5537C5.0148 10.3841 3.95455 10.1238 2.94861 9.67024C2.50065 9.46817 2.07604 9.22476 1.7139 8.88204C1.35345 8.54075 1.15508 8.13717 1.16661 7.61678C1.18547 6.76083 1.17111 5.90402 1.17196 5.0475C1.17252 4.60747 1.40072 4.37411 1.83602 4.37411C7.27684 4.37325 12.7177 4.37325 18.1585 4.37411C18.6025 4.37411 18.8256 4.60719 18.8259 5.06444C18.8265 5.90747 18.8099 6.75107 18.8318 7.59381C18.8467 8.15411 18.6275 8.58064 18.2294 8.93399Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/openinghours">Opening Hours</Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                            fill="none"
                          >
                            <path
                              d="M14.2692 16.0885C13.6448 16.6844 12.8847 17.0343 12.0847 17.3037C10.5949 17.8058 9.05611 17.9832 7.42693 18C5.76627 17.9739 4.06804 17.7697 2.44495 17.1284C1.74576 16.8521 1.09057 16.4971 0.573793 15.9252C0.18731 15.498 -0.0147308 15.0018 0.0008368 14.4141C0.0546466 12.3861 0.770418 10.6419 2.16473 9.18714C2.45815 8.88092 2.87103 8.86236 3.1526 9.13421C3.44196 9.41328 3.44297 9.83497 3.13703 10.1532C2.20602 11.1224 1.63239 12.272 1.4334 13.6106C1.39651 13.8591 1.39245 14.1127 1.36503 14.3632C1.33153 14.6732 1.46385 14.9073 1.67774 15.1069C2.09333 15.4956 2.59454 15.7311 3.11842 15.9201C4.79025 16.5232 6.52164 16.6696 8.27874 16.5923C9.51028 16.538 10.7259 16.3641 11.883 15.9139C12.3162 15.7455 12.7297 15.5125 13.127 15.2671C13.5118 15.0296 13.675 14.6712 13.6357 14.1859C13.5108 12.6397 12.9548 11.2983 11.8857 10.1841C11.709 10.0003 11.5791 9.80266 11.6112 9.53562C11.6454 9.25381 11.796 9.05414 12.0603 8.95756C12.3355 8.85721 12.5781 8.92869 12.7822 9.13456C13.6973 10.0566 14.3379 11.1457 14.7004 12.4026C14.8889 13.0562 14.9782 13.7243 14.9989 14.4048C15.0199 15.088 14.7457 15.6335 14.2692 16.0885Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M7.47329 1.47239e-05C4.86098 0.00620088 2.72314 2.18888 2.72788 4.84412C2.73295 7.52616 4.87012 9.68925 7.51593 9.68994C10.1079 9.69097 12.2712 7.51103 12.2705 4.89876C12.2698 2.15967 10.1489 -0.0065151 7.47329 1.47239e-05ZM7.47397 8.30458C5.60958 8.3008 4.09173 6.7412 4.09173 4.82934C4.09207 2.94462 5.62751 1.38503 7.48344 1.38434C9.37525 1.38399 10.9083 2.93019 10.9076 4.83862C10.9063 6.76526 9.37762 8.30836 7.47397 8.30458Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/profiledetails">Profile Details</Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M17.9986 4.00709V4.74562C17.9339 5.05344 17.8885 5.36707 17.8013 5.66869C17.5644 6.48863 17.1267 7.19964 16.5386 7.81178C15.8815 8.49604 15.2065 9.16401 14.5355 9.83469C14.3032 10.0669 14.0047 10.1158 13.7279 9.98628C13.4655 9.86338 13.3046 9.59356 13.3244 9.30357C13.3379 9.09965 13.4387 8.94071 13.5806 8.7992C14.1776 8.20334 14.7739 7.60631 15.3674 7.00657C15.9517 6.41575 16.3738 5.73537 16.5374 4.9069C16.9158 2.99603 15.236 1.19177 13.2988 1.43058C12.4381 1.53641 11.7163 1.92952 11.1072 2.52345C10.1803 3.42713 9.26457 4.34321 8.36012 5.26938C7.77898 5.86447 7.3758 6.56772 7.27461 7.40821C7.12342 8.66623 7.64329 9.61178 8.66754 10.3104C8.71096 10.3402 8.7571 10.3658 8.80091 10.3949C9.13315 10.6143 9.23239 11.0179 9.03623 11.3478C8.83696 11.6828 8.41749 11.7964 8.07246 11.5936C7.16374 11.059 6.48646 10.3135 6.11971 9.32063C5.54013 7.7513 5.85764 6.30603 6.79079 4.96389C6.92066 4.77703 7.06101 4.59288 7.22112 4.4316C8.25312 3.39262 9.26612 2.33271 10.3361 1.33404C11.3038 0.430751 12.4734 -0.0406674 13.821 0.00275271C15.8846 0.0690459 17.7431 1.79073 17.9653 3.83923C17.9719 3.89583 17.9874 3.95127 17.9986 4.00709Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M10.9863 13.3064C10.3834 14.0205 9.69452 14.6632 9.03391 15.3273C8.53846 15.8259 8.04726 16.3318 7.51653 16.7908C6.74737 17.4565 5.85028 17.8674 4.82642 17.9729C4.79851 17.9756 4.77137 17.9907 4.74423 18H3.97042C3.79946 17.9667 3.62771 17.9368 3.45752 17.8996C1.38538 17.4456 -0.0878098 15.5522 0.00407026 13.4355C0.0602838 12.1398 0.621643 11.0582 1.50516 10.1367C2.14135 9.47299 2.7973 8.82711 3.44783 8.17736C3.75216 7.87342 4.18404 7.86722 4.46821 8.15216C4.7516 8.43672 4.74385 8.86511 4.43952 9.17331C3.83047 9.79011 3.21406 10.4003 2.60502 11.0175C2.0297 11.601 1.61914 12.2759 1.45787 13.0912C1.07949 15.0021 2.76009 16.8063 4.69732 16.5683C5.56495 16.4621 6.28914 16.0624 6.90206 15.4638C7.82435 14.5632 8.73579 13.6514 9.63636 12.7295C10.2136 12.1391 10.6218 11.4459 10.7226 10.6101C10.8742 9.35552 10.3648 8.40377 9.34522 7.69819C9.2921 7.66175 9.23511 7.63151 9.18161 7.59507C8.85557 7.37409 8.76409 6.9647 8.96723 6.63711C9.16417 6.31883 9.57627 6.20252 9.90502 6.39714C11.082 7.09225 11.8477 8.09595 12.09 9.45205C12.3497 10.9082 11.9194 12.1999 10.9863 13.3064Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/socialmedia">Social Media</Link>
                      </li>
                      <li>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M17.9986 4.00709V4.74562C17.9339 5.05344 17.8885 5.36707 17.8013 5.66869C17.5644 6.48863 17.1267 7.19964 16.5386 7.81178C15.8815 8.49604 15.2065 9.16401 14.5355 9.83469C14.3032 10.0669 14.0047 10.1158 13.7279 9.98628C13.4655 9.86338 13.3046 9.59356 13.3244 9.30357C13.3379 9.09965 13.4387 8.94071 13.5806 8.7992C14.1776 8.20334 14.7739 7.60631 15.3674 7.00657C15.9517 6.41575 16.3738 5.73537 16.5374 4.9069C16.9158 2.99603 15.236 1.19177 13.2988 1.43058C12.4381 1.53641 11.7163 1.92952 11.1072 2.52345C10.1803 3.42713 9.26457 4.34321 8.36012 5.26938C7.77898 5.86447 7.3758 6.56772 7.27461 7.40821C7.12342 8.66623 7.64329 9.61178 8.66754 10.3104C8.71096 10.3402 8.7571 10.3658 8.80091 10.3949C9.13315 10.6143 9.23239 11.0179 9.03623 11.3478C8.83696 11.6828 8.41749 11.7964 8.07246 11.5936C7.16374 11.059 6.48646 10.3135 6.11971 9.32063C5.54013 7.7513 5.85764 6.30603 6.79079 4.96389C6.92066 4.77703 7.06101 4.59288 7.22112 4.4316C8.25312 3.39262 9.26612 2.33271 10.3361 1.33404C11.3038 0.430751 12.4734 -0.0406674 13.821 0.00275271C15.8846 0.0690459 17.7431 1.79073 17.9653 3.83923C17.9719 3.89583 17.9874 3.95127 17.9986 4.00709Z"
                              fill="#C8C8C8"
                            />
                            <path
                              d="M10.9863 13.3064C10.3834 14.0205 9.69452 14.6632 9.03391 15.3273C8.53846 15.8259 8.04726 16.3318 7.51653 16.7908C6.74737 17.4565 5.85028 17.8674 4.82642 17.9729C4.79851 17.9756 4.77137 17.9907 4.74423 18H3.97042C3.79946 17.9667 3.62771 17.9368 3.45752 17.8996C1.38538 17.4456 -0.0878098 15.5522 0.00407026 13.4355C0.0602838 12.1398 0.621643 11.0582 1.50516 10.1367C2.14135 9.47299 2.7973 8.82711 3.44783 8.17736C3.75216 7.87342 4.18404 7.86722 4.46821 8.15216C4.7516 8.43672 4.74385 8.86511 4.43952 9.17331C3.83047 9.79011 3.21406 10.4003 2.60502 11.0175C2.0297 11.601 1.61914 12.2759 1.45787 13.0912C1.07949 15.0021 2.76009 16.8063 4.69732 16.5683C5.56495 16.4621 6.28914 16.0624 6.90206 15.4638C7.82435 14.5632 8.73579 13.6514 9.63636 12.7295C10.2136 12.1391 10.6218 11.4459 10.7226 10.6101C10.8742 9.35552 10.3648 8.40377 9.34522 7.69819C9.2921 7.66175 9.23511 7.63151 9.18161 7.59507C8.85557 7.37409 8.76409 6.9647 8.96723 6.63711C9.16417 6.31883 9.57627 6.20252 9.90502 6.39714C11.082 7.09225 11.8477 8.09595 12.09 9.45205C12.3497 10.9082 11.9194 12.1999 10.9863 13.3064Z"
                              fill="#C8C8C8"
                            />
                          </svg>
                        </span>
                        <Link to="/marketing-preferences">
                          Marketing Preferences
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      full_name: userDetailsState?.full_name || "",
                      surname: userDetailsState?.surname || "",
                      email: userDetailsState?.email || "",
                      phone_number: userDetailsState?.phone_number || "",
                      step_type: 1,
                    }}
                    validate={(values) => {
                      const errors = {};

                      if (!values.full_name) {
                        errors.full_name = "Required*";
                      }
                      if (!values.surname) {
                        errors.surname = "Required*";
                      }

                      if (!values.phone_number) {
                        errors.phone_number = "Required*";
                      }

                      if (!values.email) {
                        errors.email = "Required*";
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                          values.email
                        )
                      ) {
                        errors.email = "Invalid email address";
                      }

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      values.id = userDetails?._id;
                      dispatch(userEditProfile(values)).then((data) => {
                        if (data?.payload?.success) {
                          resetForm();
                          toast.success(data?.payload?.message);
                          setUserDetailsState(data?.payload?.data);
                        }
                        setSubmitting(false);
                      });
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form
                        onSubmit={(e) => {
                          // setValidateValue(true);
                          handleSubmit(e);
                        }}
                      >
                        <div className="details-data-box">
                          <div className="">
                            <div className="drop-us-line mb-5">
                              <h2>Account Holder Details</h2>
                            </div>
                            <Row>
                              <Col lg={6}>
                                <div className="sign-detail-input">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Type Here..."
                                    name="full_name"
                                    onChange={handleChange}
                                    value={values.full_name}
                                  />
                                  <span className="formik-errors">
                                    {errors.full_name &&
                                      touched.full_name &&
                                      errors.full_name}
                                  </span>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="sign-detail-input">
                                  <label>Surname</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Type Here..."
                                    name="surname"
                                    onChange={handleChange}
                                    value={values.surname}
                                  />
                                  <span className="formik-errors">
                                    {errors.surname &&
                                      touched.surname &&
                                      errors.surname}
                                  </span>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="sign-detail-input">
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Type Here..."
                                    name="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    disabled
                                  />
                                  <span className="formik-errors">
                                    {errors.email &&
                                      touched.email &&
                                      errors.email}
                                  </span>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="sign-detail-input">
                                  <label>Phone Number</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Type Here..."
                                    name="phone_number"
                                    onChange={handleChange}
                                    value={values.phone_number}
                                  />
                                  <span className="formik-errors">
                                    {errors.phone_number &&
                                      touched.phone_number &&
                                      errors.phone_number}
                                  </span>
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="drop-us-submit">
                                  <button type="submit">Save Changes</button>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/*  Manage Your Account end */}

        {/* footer section start  */}

        {/* footer section end  */}
      </LoginLayout>
    </>
  );
}
